export default {
  // Mobile
  MOBILE_XS: '320px',
  MOBILE_SM: '360px',
  MOBILE_MD: '375px',
  MOBILE_LG: '414px',
  // Max
  MOBILE_XS_MAX: '359px',
  MOBILE_SM_MAX: '374px',
  MOBILE_MD_MAX: '413px',
  MOBILE_LG_MAX: '479px',
  // Min
  MOBILE_XS_MIN: '321px',
  MOBILE_SM_MIN: '361px',
  MOBILE_MD_MIN: '376px',
  MOBILE_LG_MIN: '415px',

  // Phablet
  PHABLET_XS: '480px',
  PHABLET_SM: '640px',
  PHABLET_MD: '667px',
  PHABLET_LG: '736px',
  // Max
  PHABLET_XS_MAX: '639px',
  PHABLET_SM_MAX: '665px',
  PHABLET_MD_MAX: '735px',
  PHABLET_LG_MAX: '767px',
  // Min
  PHABLET_XS_MIN: '481px',
  PHABLET_SM_MIN: '641px',
  PHABLET_MD_MIN: '668px',
  PHABLET_LG_MIN: '737px',

  // Tablet
  TABLET_XS: '768px',
  TABLET_SM: '800px',
  TABLET_MD: '812px',
  TABLET_LG: '1024px',
  // Max
  TABLET_XS_MAX: '799px',
  TABLET_SM_MAX: '811px',
  TABLET_MD_MAX: '1023px',
  TABLET_LG_MAX: '1279px',
  // Min
  TABLET_XS_MIN: '769px',
  TABLET_SM_MIN: '801px',
  TABLET_MD_MIN: '813px',
  TABLET_LG_MIN: '1025px',

  // Desktop
  DESKTOP_XS: '1280px',
  DESKTOP_SM: '1366px',
  DESKTOP_MD: '1440px',
  DESKTOP_LG: '1600px',
  DESKTOP_XL: '1920px',
  DESKTOP_XXL: '2560px',
  // Max
  DESKTOP_XS_MAX: '1365px',
  DESKTOP_SM_MAX: '1439px',
  DESKTOP_MD_MAX: '1599px',
  DESKTOP_LG_MAX: '1919px',
  DESKTOP_XL_MAX: '2559px',
  // Min
  DESKTOP_XS_MIN: '1281px',
  DESKTOP_SM_MIN: '1367px',
  DESKTOP_MD_MIN: '1441px',
  DESKTOP_LG_MIN: '1601px',
  DESKTOP_XL_MIN: '1921px',
  DESKTOP_XXL_MIN: '2561px',
}
